import { type ProductVariant, type Price } from '@commercetools/platform-sdk'
import PlentyBody from '#app/components/typography/plenty-body'
import { cn } from '#app/utils/misc'
import { moneyFormatWithTypedMoney } from '#app/utils/money'

type PriceTagProps = {
	variant: ProductVariant
}

export const PriceTag = ({ variant }: PriceTagProps) => {
	if (!variant) return null
	// maybe look the cheapest price
	const price = variant.prices?.reduce(
		(lowest, current) => {
			const currentPrice = current.discounted?.value || current.value
			const lowestPrice = lowest?.discounted?.value || lowest?.value
			if (
				!lowest ||
				(lowestPrice && currentPrice.centAmount < lowestPrice.centAmount)
			) {
				return current
			}
			return lowest
		},
		null as Price | null,
	)

	if (!price) return null
	const isDiscounted =
		price && price.discounted && price.discounted.discount.obj?.isActive
	const priceToShow = isDiscounted ? price.discounted!.value : price.value
	const originalPrice = moneyFormatWithTypedMoney(price.value)

	return (
		<div className="flex items-center md:space-x-2">
			<span>
				<PlentyBody
					size="md"
					className={cn(` font-${isDiscounted ? 'bold' : 'normal'}`)}
				>
					<span className={cn(isDiscounted ? 'text-red' : 'text-black')}>
						{`${moneyFormatWithTypedMoney(priceToShow)}`}
					</span>
				</PlentyBody>
			</span>
			{isDiscounted && (
				<div className="flex flex-row items-center space-x-2 md:space-x-2">
					<PlentyBody size="md" className="text-green-40 line-through">
						{originalPrice}
					</PlentyBody>
				</div>
			)}
		</div>
	)
}
